import { Coffee } from "lucide-react";

const PLACEHOLDER_CAFES = [
    "Brew Co.",
    "Daily Grind",
    "Bean There",
    "The Roast Room",
    "Cuppa",
    "Grounds & Co",
    "Mocha Motion",
    "Steamy's",
];

export const Partners = () => (
    <section className="border-t border-[#1f1f1f] py-20 md:py-28" data-testid="partners-section">
        <div className="mx-auto max-w-7xl px-6">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-primary">Partner cafes</p>
            <h2 className="mt-3 max-w-lg text-3xl font-extrabold tracking-tighter sm:text-4xl">
                Your favorites are <span className="text-primary">brewing on it.</span>
            </h2>
            <p className="mt-4 max-w-xl text-sm text-[#a1a1aa] md:text-base" data-testid="partners-placeholder-note">
                We're onboarding our first partner cafes right now — names shown are placeholders until launch.
            </p>
        </div>

        <div className="mt-12 overflow-hidden" data-testid="partners-marquee">
            <div className="flex w-max animate-marquee-slow gap-5 px-6">
                {[...PLACEHOLDER_CAFES, ...PLACEHOLDER_CAFES].map((name, i) => (
                    <div
                        key={`${name}-${i}`}
                        data-testid={`partner-placeholder-${i % PLACEHOLDER_CAFES.length}`}
                        className="flex items-center gap-3 rounded-2xl border border-[#2a2a2a] bg-[#161616] px-7 py-5 transition-colors duration-200 hover:border-primary"
                    >
                        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#222222] text-[#a1a1aa]">
                            <Coffee className="h-4 w-4" />
                        </span>
                        <span className="whitespace-nowrap text-base font-semibold text-[#d4d4d4]">{name}</span>
                    </div>
                ))}
            </div>
        </div>
    </section>
);
